import __var_0__ from './round2.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Round a numeric value to the nearest power of two on a linear scale.
*
* @module @stdlib/math/base/special/round2
*
* @example
* var round2 = require( '@stdlib/math/base/special/round2' );
*
* var v = round2( 3.141592653589793 );
* // returns 4.0
*
* v = round2( 13.0 );
* // returns 16.0
*
* v = round2( -0.314 );
* // returns -0.25
*/

// MODULES //
var round2 = __var_0__;


// EXPORTS //
export default round2;
